/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import type { SortDirection } from 'walden-fast/types/pagination';

export interface TableThSignature {
  // The arguments accepted by the component
  Args: {
    textAlign?: 'left' | 'right';
    sortDirection?: SortDirection;
    onSort?: (direction: SortDirection) => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class TableThComponent extends Component<TableThSignature> {
  @action
  onSort() {
    if (this.args.sortDirection === 'none') {
      this.args.onSort?.('asc');
      return;
    }
    if (this.args.sortDirection === 'asc') {
      this.args.onSort?.('desc');
      return;
    }
    if (this.args.sortDirection === 'desc') {
      this.args.onSort?.('none');
      return;
    }
  }
}
